/* eslint-disable */
/* Code generated by generator.ts DO NOT EDIT. */
// Generated: 04-11-2026 08:35:03

export enum UitstroomniveauVSO {
    VAVO = "Vavo",
    MBO_NIVEAU_1 = "MBO niveau 1",
    MBO_NIVEAU_2 = "MBO niveau 2",
    MBO_NIVEAU_3 = "MBO niveau 3",
    MBO_NIVEAU_3_4 = "MBO niveau 3/4",
    MBO_NIVEAU_4 = "MBO niveau 4",
    HBO = "HBO",
    UNIVERSITEIT = "Universiteit",
    HBO_UNIVERSITEIT = "HBO/Universiteit",
    REGULIERE_ARBEIDSPLAATS = "Reguliere arbeidsplaats",
    SOCIALE_WERKVOORZIENING = "Sociale werkvoorziening",
    BESCHUT_WERK_BESCHERMDE_WERKOMGEVING = "Beschut werk/beschermde werkomgeving",
    ARBEIDSTRAININGSCENTRUM = "Arbeidstrainingscentrum",
    DAGBESTEDING_BELEVINGSGERICHT = "Dagbesteding belevingsgericht",
    DAGBESTEDING_ACTIVEREND = "Dagbesteding activerend",
    DAGBESTEDING_ARBEIDSMATIG = "Dagbesteding arbeidsmatig",
    VRIJWILLIGERSWERK = "Vrijwilligerswerk"
}
